import React from 'react'
import { Flex } from '@mobi/component-library/Common/Flex'
import { LoadingPlaceholder } from '@mobi/component-library/Common/LoadingPlaceholder'
import { colors, radius, shadow, spacing } from '@mobi/component-library/Theme/Common'

export const SkeletonLoader: React.FC = () =>
  Array(5)
    .fill('')
    .map((_, i) => <PendingTicketLoading key={i} />)

// ===============
// Local Component
// ===============

const PendingTicketLoading: React.FC = () => (
  <div
    style={{
      padding: spacing.smx1,
      background: colors.white,
      borderRadius: radius.lgx1,
      border: `0.1rem solid ${colors.neutral[200]}`,
      boxShadow: shadow.xs,
    }}
  >
    <Flex justifyContent='space-between'>
      <LoadingPlaceholder width={spacing.huge} height={spacing.md} borderRadius={radius.lg} />
      <LoadingPlaceholder width={spacing.lgx1} height={spacing.md} borderRadius={radius.lg} />
    </Flex>

    <div
      style={{
        marginTop: '1rem',
        background: colors.surface[200],
        padding: spacing.sm,
        borderRadius: radius.lgx1,
      }}
    >
      <Flex justifyContent='space-between'>
        <Flex gap={spacing.smx2}>
          <LoadingPlaceholder width={spacing.lg} height={spacing.lg} borderRadius={radius.lg} />

          <Flex justifyContent='space-between'>
            <Flex flexDirection='column' gap={spacing.smx1}>
              <LoadingPlaceholder
                width={spacing.lgx1}
                height={spacing.md}
                borderRadius={radius.lg}
              />
              <LoadingPlaceholder
                width={spacing.huge}
                height={spacing.md}
                borderRadius={radius.lg}
              />
            </Flex>
          </Flex>
        </Flex>

        <LoadingPlaceholder width={spacing.lg} height={spacing.md} borderRadius={radius.lg} />
      </Flex>
    </div>
  </div>
)
